import { Box, Button, Card, Grid, CardMedia, CardContent, TextField } from '@mui/material';
import { DragIndicator } from '@mui/icons-material';
import React, { useContext, useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { BannerServices } from '../BannerServices';
import { Controller, useForm, useWatch } from 'react-hook-form';
import Loading from '../../../../components/Loader/Loading';
import { CustomerBannerContext } from './CustomerBanners';

const CustomerAppSlider = () => {
  const {fetchBannerList,list, setList, loading,setLoading, allRowCount, paginationModel, handlePaginationChange, handleSortingChange, sortModel, handleStatusChange} = useContext(CustomerBannerContext);
  const { control, handleSubmit, reset, setValue, getValues } = useForm({
    mode: "onChange",
    defaultValues: {
      banners: []
    }
  });
  
  const [sliders, setSliders] = useState([]);
  const [originalOrder, setOriginalOrder] = useState([]);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  // const [loading, setLoading] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);

  const watchedBanners = useWatch({
    control,
    name: "banners"
  });

  const autoSave = async (updatedBanners) => {
    console.log("Auto-saving banner positions...",updatedBanners);
    try {
      setLoading(true);
      const response = await BannerServices.updatePositions(updatedBanners);
      
      if (response.success == '1') {
        // Update original order to reflect saved state
        const newOriginalOrder = [...sliders];
        setOriginalOrder(newOriginalOrder);
        setHasChanges(false);
        setHasChanges(false);
        
        // Optional: Show brief success indicator
        
        // You could add a small toast or status indicator here
      } else {
        // If save fails, revert to original order
        handleCancel();
        Swal.fire({
          icon: 'error',
          title: 'Save Failed',
          text: response.message || 'Failed to update banner positions',
          timer: 2000
        });
      }
    } catch (error) {
      // If save fails, revert to original order
      handleCancel();
      Swal.fire({
        icon: 'error',
        title: 'Save Failed',
        text: 'An error occurred while updating banner positions',
        timer: 2000
      });
    }finally {
      setLoading(false);
    }
  };

  const checkForChanges = () => {
    if (!watchedBanners || watchedBanners.length === 0) return;
    
    let hasChange = false;
    watchedBanners.forEach((banner) => {
      const originalItem = originalOrder.find(item => item.id === banner.id);
      if (originalItem && originalItem.position !== banner.position) {
        hasChange = true;
      }
    });
    
    setHasChanges(hasChange);
  };

  const handleDragStart = (e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    setDragOverIndex(index);
  };

  const handleDragLeave = () => {
    setDragOverIndex(null);
  };

  const handleDrop = async (e, dropIndex) => {
    e.preventDefault();
    
    if (draggedIndex === null || draggedIndex === dropIndex) {
      setDraggedIndex(null);
      setDragOverIndex(null);
      return;
    }

    const newList = [...sliders];
    const draggedItem = newList[draggedIndex];
    
    newList.splice(draggedIndex, 1);
    newList.splice(dropIndex, 0, draggedItem);
    
    setSliders(newList);
    
    // Update form values
    const updatedBanners = newList.map((item, index) => ({
      id: item.id,
      position: index + 1
    }));
    
    updatedBanners.forEach((banner, index) => {
      setValue(`banners[${index}].id`, banner.id);
      setValue(`banners[${index}].position`, banner.position);
    });
    
    // Auto-save after drag/drop
    await autoSave(updatedBanners);
    
    setDraggedIndex(null);
    setDragOverIndex(null);
  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
    setDragOverIndex(null);
  };
  useEffect(() => {
    // fetchBannerList();
    if(list){
      const activeList = list.filter(item=>item.status == 'active');
      const sortedList = activeList.sort((a, b) => a.position - b.position);
        setSliders(sortedList);
        setOriginalOrder([...sortedList]);
        
        const formData = {
          banners: sortedList.map((item, index) => ({
            id: item.id,
            position: index + 1
          }))
        };
        reset(formData);
        setHasChanges(false);
    }
  }, [list]);

  useEffect(() => {
    checkForChanges();
  }, [watchedBanners, originalOrder]);

  const handleCancel = () => {
    setSliders([...originalOrder]);
    
    const formData = {
      banners: originalOrder.map(item => ({
        id: item.id,
        position: item.position
      }))
    };
    reset(formData);
    setHasChanges(false);
  };
  return (
    <Box component={'div'}>
      {loading && <Loading />}
      <Grid container spacing={1}>
        <Grid item xs={12} sm={11}>
          <Grid container spacing={1}>
            {sliders.length > 0 && sliders.map((item, index) => (
              <Grid
                item
                xs={12}
                key={item.id}
                draggable={true}
                onDragStart={(e) => handleDragStart(e, index)}
                onDragOver={(e) => handleDragOver(e, index)}
                onDragLeave={handleDragLeave}
                onDrop={(e) => handleDrop(e, index)}
                onDragEnd={handleDragEnd}
                sx={{
                  opacity: draggedIndex === index ? 0.5 : 1,
                  cursor: 'grab',
                  '&:active': {
                    cursor: 'grabbing'
                  },
                  position: 'relative',
                  '&::before': dragOverIndex === index && draggedIndex !== index ? {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    border: '2px dashed #2196f3',
                    borderRadius: '4px',
                    zIndex: 1,
                    pointerEvents: 'none'
                  } : {}
                }}
              >
                <Card sx={{
                  position: 'relative',
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-2px)',
                    transition: 'all 0.2s ease-in-out'
                  }
                }}>
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 8,
                      right: 8,
                      zIndex: 2,
                      backgroundColor: 'rgba(255, 255, 255, 0.9)',
                      borderRadius: '50%',
                      padding: '4px'
                    }}
                  >
                    <DragIndicator
                      sx={{
                        color: '#666',
                        fontSize: '20px',
                        cursor: 'grab'
                      }}
                    />
                  </Box>

                  <Box
                    sx={{
                      position: 'absolute',
                      top: 8,
                      left: 8,
                      backgroundColor: 'primary.main',
                      color: 'white',
                      borderRadius: '50%',
                      width: 24,
                      height: 24,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      zIndex: 2
                    }}
                  >
                    {watchedBanners?.[index]?.position || index + 1}
                  </Box>

                  <CardMedia
                    component="img"
                    alt={item.title}
                    height="140"
                    image={`${process.env.REACT_APP_IMAGE_STORE_PATH}/${item?.imageUrl}`}
                  />
                  
                  <CardContent sx={{
                    p: '1%',
                    '&:last-child': {
                      pb: '0!important'
                    }
                  }}>
                    {/* TextField hidden - position controlled by drag/drop only */}
                    <Controller
                      control={control}
                      name={`banners[${index}].position`}
                      render={({ field }) => (
                        <input
                          {...field}
                          type="hidden"
                        />
                      )}
                    />
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>
        
        {/*  */}
      </Grid>
    </Box>
  );
};

export default CustomerAppSlider;